var _path, _rect, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 480,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3ddab4",
    d: "M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.707,
    height: 5.649,
    x: 15.726,
    y: 16.364,
    fill: "#6c19ff",
    transform: "rotate(-46.06 33.58 19.187)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2100c4",
    d: "M38.396,10.117L19.158,30.086l4.067,3.919L41.75,14.777C40.858,13.064,39.725,11.495,38.396,10.117z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.649,
    height: 16.857,
    x: 16.276,
    y: 17.713,
    fill: "#2100c4",
    transform: "rotate(-46.188 19.1 26.141)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.0104a1f9649df98d33dabd203f0042b6.svg";
export { ForwardRef as ReactComponent };